module.exports = __webpack_public_path__ + "img/delete.bf289db3.svg";